//NOTE
// This should be a single named route middleware but it's used as global at the moment.
// When it is used as not global, as value of middleware field in definePageMeta it shows error

/**
 * Middleware to handle navigation to wishlist pages.
 *
 * This middleware redirects logged-in users from the guest wishlist page
 * to the authenticated wishlist page. Currently used as a global middleware.
 *
 * @note This middleware is currently used globally, which may cause routing issues.
 * @returns {void|NavigationFailure} Redirects to authenticated wishlist if user is logged in
 * @example
 * // Automatically redirects logged-in users from guest wishlist to authenticated wishlist
 * export default defineNuxtRouteMiddleware((to) => { ... })
 */
export default defineNuxtRouteMiddleware(to => {
  const { guestWishlist, wishlist, getCanonicalUrl } = useRouteHelper()
  const { loggedIn: isLogged } = useUserSession()

  if (
    (to.path === guestWishlist || to.path === guestWishlist + '/') &&
    isLogged.value
  ) {
    const path = getCanonicalUrl(wishlist)
    navigateTo(path)
  }
})
